// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_qQFFz","review-button-warp":"review-button-warp_AOf3c","review-button":"review-button_HBpvr"};